import { render } from "./MarketDetailsModal.vue?vue&type=template&id=35e2d8d2&scoped=true"
import script from "./MarketDetailsModal.vue?vue&type=script&lang=js"
export * from "./MarketDetailsModal.vue?vue&type=script&lang=js"

import "./MarketDetailsModal.vue?vue&type=style&index=0&id=35e2d8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e2d8d2"]])

export default __exports__